import { motion } from 'framer-motion';
import { Mail } from 'lucide-react';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import api from '../config/axiosConfig';

const PerspectiveGrid = () => (
  <div
    style={{
      position: 'absolute',
      inset: 0,
      pointerEvents: 'none',
      backgroundImage: `
        linear-gradient(to right, rgba(34,211,238,0.06) 1px, transparent 1px),
        linear-gradient(to bottom, rgba(245,158,11,0.06) 1px, transparent 1px)
      `,
      backgroundSize: '80px 80px',
      maskImage: 'radial-gradient(circle at 50% 50%, black 40%, transparent 100%)',
    }}
  />
);

const RegisterSuccessPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const { email } = location.state || {};

  const [isResending, setIsResending] = useState(false);

  const handleResend = async () => {
    if (!email) {
      toast.error("Email non disponible");
      return;
    }

    setIsResending(true);
    try {
      await api.post('/auth/resend-verification', { email });
      toast.success("Un nouvel email de vérification a été envoyé à " + email);
    } catch (err) {
      toast.error(err?.response?.data?.message || "Impossible de renvoyer l'email");
    } finally {
      setIsResending(false);
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#020617',
        position: 'relative',
        overflow: 'hidden',
        fontFamily: 'monospace',
      }}
    >
      <PerspectiveGrid />

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        style={{ width: '100%', maxWidth: 480, padding: '0 1.5rem', zIndex: 20 }}
      >
        <div
          style={{
            background: 'rgba(2,6,23,0.85)',
            backdropFilter: 'blur(24px)',
            border: '1px solid rgba(255,255,255,0.08)',
            padding: '3.5rem 2.5rem',
            textAlign: 'center',
          }}
        >
          <Mail size={56} style={{ color: '#22d3ee', marginBottom: '1.8rem' }} />

          <h1 style={{ 
            fontSize: '1.2rem', 
            letterSpacing: '0.1em', 
            marginBottom: '1rem',
            color: '#e2e8f0'
          }}>
            COMPTE CRÉÉ AVEC SUCCÈS
          </h1>

          <p style={{ 
            fontSize: '0.85rem', 
            lineHeight: 1.75, 
            color: 'rgba(255,255,255,0.8)',
            marginBottom: '2.2rem'
          }}>
            Un email de confirmation a été envoyé à :<br />
            <strong style={{ color: '#22d3ee' }}>{email}</strong>
          </p>

          <p style={{ 
            fontSize: '0.7rem', 
            color: 'rgba(255,255,255,0.55)', 
            marginBottom: '2.5rem' 
          }}>
            Veuillez vérifier votre boîte de réception (y compris les spams) dans les 24 heures<br />
            pour activer votre compte.
          </p> 

          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            <motion.button
              onClick={handleResend}
              disabled={isResending}
              whileHover={!isResending ? { scale: 1.03 } : {}}
              style={{
                padding: '1.05rem',
                background: 'rgba(34,211,238,0.08)',
                border: '1px solid #22d3ee',
                color: '#22d3ee',
                fontSize: '0.64rem',
                letterSpacing: '0.22em',
                textTransform: 'uppercase',
                cursor: isResending ? 'not-allowed' : 'pointer',
              }}
            >
              {isResending ? 'ENVOI EN COURS...' : 'RENVOYER L\'EMAIL'}
            </motion.button>

            <motion.button
              onClick={() => navigate('/home-page', { 
                state: { plan: location.state?.plan }
              })}
              whileHover={{ scale: 1.03 }}
              style={{
                padding: '1.05rem',
                background: '#f59e0b',
                color: '#020617',
                border: 'none',
                fontSize: '0.64rem',
                fontWeight: 700,
                letterSpacing: '0.22em',
                textTransform: 'uppercase',
                cursor: 'pointer',
              }}
            >
              RETOUR PAGE D'ACCUEIL →
            </motion.button>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default RegisterSuccessPage;